import { styled } from '@mui/material';

export const PageW = styled('div')`
  padding-top: 64px;
  padding-left: 38px;

  @media (max-width: 1023px) {
    padding-left: 0px;
    padding-bottom: 16px;
  }
`;

export const ContentW = styled('div')`
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: flex-start;
`;
